<div class="modal no-print" [id]="id" aria-hidden="true" [class.is-open]="isOpen$ | async">
  <div class="modal__overlay bg-modal" tabindex="-1" (click)="close()">
    <div
      class="modal__container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="title"
      (click)="$event.stopPropagation()"
      [ngStyle]="{
        'min-width.px': minWidthPx,
        'min-height.%': minHeightPercent,
        'max-width.px': maxWidthPx
      }"
    >
      <header class="modal__header mb-4 mt-4">
        <h1 class="modal__title" [id]="title">{{ title }}</h1>
        <ng-content select="[bom-modal-header]"></ng-content>
      </header>
      <main class="modal__content"><ng-content select="[bom-modal-content]"></ng-content></main>
      <footer class="modal__footer mb-6">
        <ng-content select="[bom-modal-footer]"></ng-content>
      </footer>
      <button
        class="modal__close button button-quaternary"
        [attr.aria-label]="'Luk' | tekstresource"
        (click)="close()"
        #closeButton
        [disabled]="!(canClose$ | async)"
      >
        {{ 'Luk' | tekstresource }}
      </button>
    </div>
  </div>
</div>
